<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold" *ngIf="mode === 'CREATE'">
      {{ "SPECIFIC_CONDITION.TITLE" | translate }}
    </div>
    <div class="panel-title text-bold" *ngIf="mode === 'EDIT'">
      {{ "SPECIFIC_CONDITION.EDIT_TITLE" | translate }}
    </div>
    <button
      mat-icon-button
      type="button"
      class="panel-close-btn"
      (click)="close()"
      aria-label="Close panel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="panel-body">
    <div class="flex-column-center-start">
      <div class="item-full-width flex-column-center-start">
        <app-gt2-select
          *ngIf="mode === 'CREATE'"
          [service]="specificConditionService"
          [placeHolder]="
            'SPECIFIC_CONDITION.SELECT_SPECIFIC_CONDITION' | translate
          "
          [label]="''"
          [selectedModel]="selectedSpecificCondition"
          (changeEvent)="onSpecificConditioneChange($event)"
          [noResultsLabel]="translate.instant('GENERIC.NO_RESULTS')"
          [nullableUseNone]="false"
          class="item-full-width fxFlex-100p"
        ></app-gt2-select>
      </div>
    </div>

    <div *ngIf="loading" class="flex-row-center-start">
      <mat-spinner [diameter]="40" class="mt-20"></mat-spinner>
    </div>
  </div>

  <footer class="panel-footer gt2-buttons-theme flex-row-center-center">
    <button
      mat-raised-button
      [disabled]="!selectedSpecificCondition || loading"
      color="accent"
      class="mr-8 ml-8 mt-4 mb-4"
      (click)="onCreateSpecificCondition()"
    >
      {{ "GENERIC.SAVE" | translate }}
    </button>

    <button
      *ngIf="mode === 'CREATE'"
      mat-stroked-button
      [disabled]="!selectedSpecificCondition || loading"
      class="mr-8 mt-4 mb-4"
      (click)="onCreateSpecificCondition(true)"
    >
      {{ "SPECIFIC_CONDITION.CREATE_AND_ADD" | translate }}
    </button>

    <button
      mat-raised-button
      color="primary"
      (click)="close()"
      class="mr-8 ml-8 mt-4 mb-4"
    >
      {{ "GENERIC.CANCEL" | translate }}
    </button>
  </footer>
</div>
